import React from 'react';

import cx from 'classnames';
import { Field, Form } from 'react-final-form';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import FormErrorText from 'components/shared/FormErrorText';
import TermsAndConds from 'components/shared/TermsAndConds';
import AuthTitle from 'components/shared/Typography/AuthTitle';
import { usePrivacyPolicy } from 'hooks/usePrivacyPolicy';
import useValidationSchema from 'hooks/useValidationSchema';
import { guestPortalIdSelector } from 'store/app/selectors';

import { GP_AUTH_FORGOT_ROUTE } from '../../Routes/constants';
import { useGuestPortalRouteBuilder } from '../../Routes/functions';
import { useSignIn } from './functions';
import styles from './index.module.css';
import { validationSchema } from './validationSchema';

function SignIn() {
  const guestPortalId = useSelector(guestPortalIdSelector);
  usePrivacyPolicy(guestPortalId);

  const { predefinedEmail, isChecked, useCustomPrivacyPolicy, toggleCheckbox, handleSubmit } = useSignIn();
  const validate = useValidationSchema(validationSchema);
  const { buildRoute } = useGuestPortalRouteBuilder();

  return (
    <Form initialValues={{ email: predefinedEmail }} onSubmit={handleSubmit} validate={validate}>
      {({ handleSubmit, submitting, hasValidationErrors, submitError }) => {
        return (
          <form onSubmit={handleSubmit}>
            <AuthTitle>Log in to get started</AuthTitle>
            {/*please do not remove "spellCheck" prop for email field, it fixes bug in safari*/}
            <Field component={FormGroupAdapter} name="email" placeholder="Email" type="text" spellCheck={false} />
            <Field
              component={FormGroupAdapter}
              name="password"
              placeholder="Password"
              type="password"
              withIcon
              noMargin
            />

            {submitError && <FormErrorText>{submitError}</FormErrorText>}

            <div className={cx(styles.resetPswrdLink, 'custom-gp-auth-reset-pswrd-link')}>
              <Link to={buildRoute(GP_AUTH_FORGOT_ROUTE)} className="link">
                Forgot Password
              </Link>
            </div>

            <TermsAndConds actionName="Log in" toggleCheckbox={toggleCheckbox} isChecked={isChecked} />

            <FormActions isRight>
              <Button
                htmlType="submit"
                disabled={(useCustomPrivacyPolicy && !isChecked) || submitting || hasValidationErrors}
              >
                Log in
              </Button>
            </FormActions>
          </form>
        );
      }}
    </Form>
  );
}

export default SignIn;
